<div class="widget">
    <label
        [attr.for]="id"
        class="horizontal control-label"
    >{{schema.description}}</label>
    <editor
        [formControl]="control"
        [id]="id"
        [init]="initObject"
        (onInit)="angularInit()"

        (onSetContent)="angularSetContent()"
        (onInitNgModel)="realAngularInit($event)"

    ></editor>

</div>
